function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{opacity:0.4295;enable-background:new    ;}\n\t.st1{opacity:0.1255;fill:#0D6D9E;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill:#D6DCE4;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("rect", {
  className: "st1",
  width: 567.1,
  height: 302.6
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 283.5,
  cy: 151.3,
  r: 100
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M218.9,129.8v43.1h28.7l35.9,35.9V93.9l-35.9,35.9H218.9z M315.8,151.3c0-12.7-7.3-23.6-17.9-28.9v57.8 C308.5,174.9,315.8,164,315.8,151.3z M297.9,88.4v14.8c20.7,6.2,35.9,25.4,35.9,48.1s-15.1,42-35.9,48.1v14.8 c28.8-6.5,50.2-32.2,50.2-62.9S326.6,94.9,297.9,88.4z"
});

function SvgAudioAssetTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 567.1 302.6",
    style: {
      enableBackground: "new 0 0 567.1 302.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioAssetTypeIcon);
export default __webpack_public_path__ + "static/media/audio-asset-type-icon.6833615b.svg";
export { ForwardRef as ReactComponent };